import React, { useEffect, useState } from 'react'
import EmrVisitsService from '../../../services/EmrVisitsService';

const AbormalFindingsSection = (props) => {
    const{visit_id,selectedTab,Headers}=props
    const[historyData,setHistoryData]=useState([])
    useEffect(()=>{                
        if(selectedTab=='History'){
         fetchHistoryList()
        }
    },[Headers])
    useEffect(()=>{
        fetchHistoryList()
    },[])
    const fetchHistoryList=async()=>{
        try{
        const selectedSubTab=['HPI','PMH','ROS']
            const responses = await Promise.all(
                selectedSubTab.map(tab =>
                    EmrVisitsService.getEmrChartByScreen(tab, visit_id, {
                        is_active: 1,
                        selected_BodyParts: ""
                    })
                )
            );

            const mergedData = responses.flatMap(res => res.data);            
            setHistoryData(mergedData)            
    }catch(err){

    }
    }
    const filteredData = historyData.filter(
        (item) => !(item.is_chart_updated === false && item.is_normal === false)
    );
  return (
      <div class="col-4">
          <div class="card sh_basecard cardhtmd">
              <div class="card-header p-2 sh_basecardHeader">
                  <div class="d-flex w-100 justify-content-between align-items-center ">
                      Abnormal Findings
                  </div>
              </div>
              <div class="card-body py-2 px-0 sh_basecardBody">
                  <table class="table sh_tablenew">
                      <thead>
                          <tr>
                              <th>Type</th>
                              <th>Findings</th>
                          </tr>
                      </thead>
                      <tbody>
                          {filteredData.length > 0 ? (
                              filteredData.map((item, index) => (
                                  <tr key={index}>
                                      <td><a>{item.name}</a></td>
                                      <td>{item.is_chart === true ? 'Positive' : 'Negative'}</td>
                                  </tr>
                              ))
                          ) : (
                              <tr>
                                  <td colSpan="2">No findings found</td>
                              </tr>
                          )}
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
  )
}

export default AbormalFindingsSection